import React, {useState, useEffect} from "react";
import { useSelector } from 'react-redux'

import { styled } from '@mui/material/styles';
import { Box } from "@mui/system";
import LinearProgress from '@mui/material/LinearProgress';
import { Paper, Typography } from "@mui/material";
import { selectQuestions } from "../../../reducers/survey_question";

const ProgressBar = (props) => {
  const Questions = useSelector(state => selectQuestions(state))
  const [sticky, setSticky] = useState('relative')
  const [progressvalue, setProgressValue] = useState(0)

  
  useEffect(() => {
    window.addEventListener('scroll', isSticky);
    return () => {
        window.removeEventListener('scroll', isSticky);
    };
  }, []); 

  useEffect(() => {
    let displayed = Questions.filter(question=>question.QuestionDisplayedFlag == "1" && question.QuestionRequiredFlag == "1").length
    let answered = Questions.filter(question=>question.Responses[0].Response.length && question.Responses[0].Response !== "-1" && question.QuestionDisplayedFlag == "1" && question.QuestionRequiredFlag == "1").length
    let calcValue = (answered/displayed)*100
    setProgressValue((oldValue) => {
      if(oldValue === 100){
        return 100
      }
      return Math.min(calcValue, 100)
    })
  }, [Questions])


  const isSticky = () => {
    const scrollTop = window.scrollY;
    const stickyClass = scrollTop >= 150 ? 'fixed' : 'relative'
    if(stickyClass != sticky) setSticky('fixed')
  }

  return <Box role="progressbar" sx={{
            position: sticky,
            top:'0px',
            height:'35px',
            width:'100%',
            left:'0px',
            zIndex:'1'
          }}><Paper elevation={12}>
          <LinearProgress variant="determinate" value={progressvalue} 
          height={10}
          sx={{margin:'0px', height:'12px'}}/>

          </Paper>
          
        </Box>
}

export default ProgressBar